var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeeDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4816 5.76575C11.143 5.76575 10.6944 5.75825 10.136 5.75825C8.77403 5.75825 7.65413 4.631 7.65413 3.25625V0.84425C7.65413 0.6545 7.5027 0.5 7.31475 0.5H3.34772C1.49638 0.5 0 2.0195 0 3.88175V11.963C0 13.9167 1.56767 15.5 3.50219 15.5H9.40973C11.2544 15.5 12.75 13.9902 12.75 12.1265V6.10325C12.75 5.91275 12.5993 5.759 12.4106 5.75975C12.0935 5.762 11.7133 5.76575 11.4816 5.76575Z",
    fill: "#86A0D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43802 0.925527C9.21377 0.692277 8.82227 0.852777 8.82227 1.17603V3.15378C8.82227 3.98328 9.50551 4.66578 10.335 4.66578C10.8578 4.67178 11.5838 4.67328 12.2003 4.67178C12.516 4.67103 12.6765 4.29378 12.4575 4.06578C11.6663 3.24303 10.2495 1.76853 9.43802 0.925527Z",
    fill: "#86A0D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0841 8.04569L11.0841 8.04569L11.0818 8.04538C10.8747 8.0173 10.6699 8.00352 10.4648 8.00007L10.4648 8H10.4564C7.97253 8 5.95801 10.0145 5.95801 12.4984C5.95801 13.2741 6.15561 14.0046 6.50102 14.6428C7.25948 16.0467 8.74841 17 10.4564 17C12.9403 17 14.9548 14.9854 14.9548 12.5015C14.9548 10.229 13.2717 8.35252 11.0841 8.04569Z",
    fill: "#B5CAF3",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6793 10.1876C10.6198 10.1249 10.5381 10.0872 10.4504 10.0872C10.3625 10.0872 10.281 10.1249 10.2214 10.1876L8.38366 12.1602C8.26456 12.2856 8.27398 12.4864 8.39942 12.6023C8.45892 12.6588 8.53744 12.6871 8.61271 12.6871C8.6973 12.6871 8.78507 12.6525 8.84783 12.5867L10.1462 11.1974V14.622C10.1462 14.7945 10.2873 14.9356 10.4597 14.9356C10.6323 14.9356 10.7734 14.7945 10.7734 14.622V11.1974L12.0623 12.5867C12.1815 12.7121 12.3759 12.7215 12.5044 12.6023C12.6299 12.4832 12.6361 12.2856 12.5201 12.1602L10.6793 10.1876Z",
    fill: "#526B9C",
    stroke: "#526B9C",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeDocuments);
export default __webpack_public_path__ + "static/media/seeDocuments.390fc639882a1336941a5db8f45cf02d.svg";
export { ForwardRef as ReactComponent };